import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  OnDestroy,
  ViewChild,
  Input,
} from '@angular/core';
import { EMPTY } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { VouchersService } from '../../../services/vouchers.service';
import { SubSink } from 'subsink';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Voucher } from 'src/app/shared';

@Component({
  selector: 'payment-voucher-input',
  templateUrl: './voucher-input.component.html',
  styleUrls: ['./voucher-input.component.scss'],
})
export class VoucherInputComponent implements OnInit, OnDestroy {
  @Input('voucher') selectedVoucher!: Voucher | undefined;
  @Output('voucherChange') voucherSelect: EventEmitter<Voucher> =
    new EventEmitter();

  @ViewChild('voucherCodeInput') voucherCodeInput!: any;

  private get inputNativeElement(): any | undefined {
    return this.voucherCodeInput?.nativeElement;
  }

  public set codeSelected(value: boolean) {
    if (value) {
      this.voucherSelect.emit({
        code: this.selectedVoucher?.code
      } as Voucher)
    }

    this._codeSelected = value;
  }
  public get codeSelected(): boolean {
    if (this.selectedVoucher) return true;

    return this._codeSelected;
  }

  public loading: boolean = false;
  private subLink = new SubSink();
  private _codeSelected: boolean = false;

  constructor(
    private VoucherService: VouchersService,
    private snackbar: MatSnackBar
  ) {
    // this.selectedVoucher = new class implements Voucher {
    //   amount: number;
    //   code: number;
    //   createdAt: Date;
    //   id: number;
    //   maxUses: number;
    //   name: string;
    //   updatedAt: Date;
    // }
  }
  ngOnInit(): void {}

  checkCode(vCode: string) {
    if (!vCode) return;

    this.loading = true;
    this.subLink.sink = this.VoucherService.checkVoucherCode(vCode)
      .pipe(
        catchError((err) => {
          this.displayMessage('متاسفانه کد تخفیف شما یافت نشد.');
          this.inputNativeElement.style.color = 'red';

          this.loading = false;
          this.codeSelected = false;

          return EMPTY;
        })
      )
      .subscribe((data) => {
        if (data) {
          this.displayMessage('کد تخفیف با موفقیت اعمال شد.');

          this.loading = false;
          this.codeSelected = true;
          this.voucherSelect.emit(data);
        }
      });
  }

  voucherChanged(e: any) {
    console.log(`${JSON.stringify(e.target.value)}`);

    this.voucherSelect.emit({
      code: e.target.value
    } as Voucher)
  }

  displayMessage(message: string) {
    this.snackbar.open(message, 'باشه', { duration: 1500 });
  }

  ngOnDestroy(): void {
    this.subLink.unsubscribe();
  }

  protected readonly console = console;
}
